import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useIsInViewport } from '~/utils'

const InViewPort = ({ inViewCallback, outViewCallback, children }) => {
  const ref = useRef(null)

  const isInViewport = useIsInViewport(ref)

  useEffect(() => {
    if (isInViewport) {
      inViewCallback && inViewCallback(true)
    } else {
      outViewCallback && outViewCallback(true)
    }
  }, [isInViewport])

  return <div ref={ref}>{children}</div>
}

InViewPort.propTypes = {
  children: PropTypes.node,

  inViewCallback: PropTypes.func,
  outViewCallback: PropTypes.func,
}

export default InViewPort
